module.exports = __webpack_public_path__ + "static/media/exp-shield.0997c128.png";